@if (!expanded) {
  <button (click)="setExpanded(true)" #button type="button"
          class="rounded-md inline-flex gap-x-2 items-center text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer"
          id="expand">
    <div class="h-4 w-4" #icon>
      <ng-content select="[icon]">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
          <path
            d="M236 192a12 12 0 0 1-12 12h-63.06a19.89 19.89 0 0 1-17.88-11.06L92.58 92H32a12 12 0 0 1 0-24h63.06a19.89 19.89 0 0 1 17.88 11.06L163.42 180H224a12 12 0 0 1 12 12M152 92h72a12 12 0 0 0 0-24h-72a12 12 0 0 0 0 24"/>
        </svg>
      </ng-content>
    </div>
    <span>{{ expandText }}</span>
  </button>
} @else {
  <button (click)="setExpanded(false)"
          class="mb-3 rounded-md inline-flex gap-x-2 items-center text-theme-primary-700 hover:text-theme-primary-900 cursor-pointer"
          id="collapse">
    <div class="h-4 w-4">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
        <path
          d="M208.49 191.51a12 12 0 0 1-17 17L128 145l-63.51 63.49a12 12 0 0 1-17-17L111 128L47.51 64.49a12 12 0 0 1 17-17L128 111l63.51-63.52a12 12 0 0 1 17 17L145 128Z"/>
      </svg>
    </div>
    <span>{{ collapseText }}</span>
  </button>

  <ng-content></ng-content>
}

<ng-content select="[overlay]"></ng-content>
